import { render } from "./TransferDetails.vue?vue&type=template&id=f2c9b532"
import script from "./TransferDetails.vue?vue&type=script&lang=js"
export * from "./TransferDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__